import React, { useEffect } from "react";
import {
  Button,
  Divider,
  FormFieldSet,
  PageHeader,
  PageTitle,
  useFormHandler,
} from "../../../../../../../components";
import { PayFrequency } from "../../../../../../../assets/data/enumData";
import { filterEmptyValues } from "../../../../../../../utils/filterEmptyValues";
import { addNewImmigrationsStart, updateImmigrationsStart } from "../../../../../../../redux/slices/immigration/immigrationSlice";
import { useDispatch, useSelector } from "react-redux";

const JobDetails = ({ onCancel, isEdit, setIsEdit, data,editData = null }) => {
    const isEditable = !!editData;
   const dispatch = useDispatch();
     const { immigrations: immigrationTableData, currentImmgration } = useSelector(
    (state) => state.immigration
  );
  const { formData, errors, handleChange, validateAllFields } = useFormHandler(
    {
      billableClient: "",
      jobTitle: "",
      jobStartDate: "",
      jobEndDate: "",
      comments: "",
      effectiveDate: "",
      effectiveUntil: "",
      payRate: "",
      payType: "",
    }
    // {
    //   billableClient: {
    //     type: "text",
    //     required: true,
    //   },
    //   jobTitle: {
    //     type: "title",
    //     required: true,
    //   },
    // }
  );
  const handleSave = () => {
    const isValid = validateAllFields();
    if (isValid) {
      const updateJobDeatils = {
        jobDetails: {
          billClient: formData.billableClient?.value ?? formData.billableClient,
          entityType: formData.billableClient?.coll,
          jobTitle: formData.jobTitle?.value ?? formData?.jobTitle,
          startDate: formData.jobStartDate,
          endDate: formData.jobEndDate,
          comment: formData.comments,
        },
        payRevision: {
          effectiveFrom: formData.effectiveDate,
          effectiveTill: formData.effectiveUntil,
          payRate: formData.payRate,
          payType: formData.payType,
        },
      };
       const isEditing = !!(currentImmgration?.uiid || editData?.uiid||currentImmgration?.data?.uiid);
const uiid = isEditing ? (currentImmgration?.uiid || editData?.uiid||currentImmgration?.data?.uiid) : "";
      const submissionData = filterEmptyValues(updateJobDeatils);
        dispatch(
        addNewImmigrationsStart({
          uiid: uiid,
          coll: "LCA",
           rsd:submissionData,
            rsn:"lcaInfoJob",
          payload: [
            {
              type: "SET",
              value: {
                  ...submissionData,
              },
            },
          ],
          onSuccess: async (payload) => {
          onCancel()
          },
        })
      );
    } else {
      console.log("errors", errors);
    }
  };
   useEffect(() => {
      const lcaInfoJob = currentImmgration?.lcaInfoJob;
      if (lcaInfoJob) {
       handleChange("billableClient", lcaInfoJob?.jobDetails?.billClient)
       handleChange("jobTitle", lcaInfoJob?.jobDetails?.jobTitle)
       handleChange("jobStartDate", lcaInfoJob?.jobDetails?.startDate)
       handleChange("jobEndDate", lcaInfoJob?.jobDetails?.endDate)
       handleChange("comments", lcaInfoJob?.jobDetails?.comment)
       handleChange("effectiveDate", lcaInfoJob?.payRevision?.effectiveFrom)
       handleChange("effectiveUntil", lcaInfoJob?.payRevision?.effectiveTill)
       handleChange("payRate", lcaInfoJob?.payRevision?.payRate)
       handleChange("payType", lcaInfoJob?.payRevision?.payType)
      }
   },[])
    useEffect(() => {
         const lcaInfoJob = editData;
          const lcaInfoData=currentImmgration?.lcaInfoJob;
         if (lcaInfoJob&&isEditable&&!lcaInfoData) {
          handleChange("billableClient", lcaInfoJob?.jobDetails?.billClient?.businessName?{label:lcaInfoJob?.jobDetails?.billClient?.businessName,value:lcaInfoJob?.jobDetails?.billClient?.uiid,coll:lcaInfoJob?.jobDetails?.entityType}:"")
          handleChange("jobTitle", lcaInfoJob?.jobDetails?.jobTitle)
          handleChange("jobStartDate", lcaInfoJob?.jobDetails?.startDate)
          handleChange("jobEndDate", lcaInfoJob?.jobDetails?.endDate)
          handleChange("comments", lcaInfoJob?.jobDetails?.comment)
          handleChange("effectiveDate", lcaInfoJob?.payRevision?.effectiveFrom)
          handleChange("effectiveUntil", lcaInfoJob?.payRevision?.effectiveTill)
          handleChange("payRate", lcaInfoJob?.payRevision?.payRate)
          handleChange("payType", lcaInfoJob?.payRevision?.payType)
         }
      },[])
  return (
    <div className="px-8 py-6 border-[1px] border-neutrals-50 overflow-auto! h-[73vh]">
      <div>
        {isEdit && (
          <div className="mb-2">
            <PageHeader
              Section={
                <div className="flex">
                  <Button
                    // type="icon"
                    variant="text"
                    icon={"arrow_left_alt"}
                    color="black"
                    title={"View LCA"}
                    onClick={onCancel}
                    className="pl-0!"
                  />
                  {/* <PageTitle title={"View LCA"} tag="p" /> */}
                </div>
              }
              RightSection={
                <div>
                  <Button title={"Edit"} onClick={() => setIsEdit(false)} />
                </div>
              }
            />
          </div>
        )}
        <p>JOB DETAILS</p>
        <Divider />
        <div className="grid grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 mt-6 gap-x-6 gap-y-8">
          <FormFieldSet
            type="allClientsList"
            title={"Billable Client"}
            placeholder="Enter Billable Client"
            value={formData.billableClient}
            onChange={(value) => handleChange("billableClient", value)}
            error={errors.billableClient}
            disabled={isEdit}
            showSearch
          />
          <FormFieldSet
            type="jobTitle"
            title={"Job Title"}
            placeholder="Select Job Title"
            value={formData.jobTitle}
            onChange={(value) => handleChange("jobTitle", value)}
            error={errors.jobTitle}
            disabled={isEdit}
            showSearch
            showButton
          />
          <FormFieldSet
            type="datepicker"
            title={"Job Start Date"}
            placeholder="Select Job Start Date"
            value={formData.jobStartDate}
            onChange={(value) => handleChange("jobStartDate", value)}
            error={errors.jobStartDate}
            disabled={isEdit}
            showDropdown={false}
          />
          <FormFieldSet
            type="datepicker"
            title={"Job End Date"}
            placeholder="Select Job End Date"
            value={formData.jobEndDate}
            onChange={(value) => handleChange("jobEndDate", value)}
            error={errors.jobEndDate}
            disabled={isEdit}
            showDropdown={false}
          />
          <FormFieldSet
            type="textArea"
            title={"Comments"}
            placeholder="Enter Comments"
            value={formData.comments}
            onChange={(value) => handleChange("comments", value)}
            error={errors.comments}
            disabled={isEdit}
          />
        </div>
        <div className="mt-6">
          <p> PAYMENT REVISIONS</p>
          <Divider />
        </div>
        <div className="grid grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 mt-6 gap-x-6 gap-y-8 ">
          <FormFieldSet
            type="datepicker"
            title={"Effective Date"}
            placeholder="Select Effective Date"
            value={formData.effectiveDate}
            onChange={(value) => handleChange("effectiveDate", value)}
            error={errors.effectiveDate}
            disabled={isEdit}
            showDropdown={false}
          />
          <FormFieldSet
            type="datepicker"
            title={"Effective Until"}
            placeholder="select Effective Until"
            value={formData.effectiveUntil}
            onChange={(value) => handleChange("effectiveUntil", value)}
            error={errors.effectiveUntil}
            disabled={isEdit}
            showDropdown={false}
          />
          <FormFieldSet
            type="text"
            title={"Pay Rate"}
            placeholder="Enter Pay Rate"
            value={formData.payRate}
            onChange={(value) => handleChange("payRate", value)}
            error={errors.payRate}
            disabled={isEdit}
          />
          <FormFieldSet
            type="select"
            title={"Pay Type"}
            placeholder="Select Pay Type"
            value={formData.payType}
            onChange={(value) => handleChange("payType", value)}
            error={errors.payType}
            options={PayFrequency}
            disabled={isEdit}
          />
        </div>
        <div className="mt-6 mb-3">
          <p> ROLES & RESPONSIBILITIES </p>
          <Divider />

          <div className="border-[1px] border-neutrals-100 min-h-[250px] mt-4 p-6 rounded-md">
            <h6>text Editor</h6>
          </div>
        </div>
        <div className="flex gap-3 justify-end my-6">
          <Button
            title="Cancel"
            variant="outlined"
            onClick={onCancel}
            disabled={isEdit}
          />
          <Button title="Save" onClick={() => handleSave()} disabled={isEdit} />
        </div>
      </div>
    </div>
  );
};

export default JobDetails;
